import React from "react";
import cx from "classnames";
import { number, array, func, string } from "prop-types";

const propTypes = {
  active: number,
  items: array,
  handleClick: func,
  page: string,
};

const Indicators = (props) => {
  const { active, items, handleClick, page } = props;

  return items ? (
    <div
      className="btn-group"
      style={{ maxWidth: page === "department" ? "654px" : "auto" }}
    >
      {items.map((item) => {
        return (
          <button
            key={JSON.stringify(item)}
            className={cx("btn ", { "is-active": active === item.id })}
            onClick={(e) => handleClick(item.id)}
          >
            {item.value}
          </button>
        );
      })}
    </div>
  ) : (
    false
  );
};

Indicators.propTypes = propTypes;
export default Indicators;
